export default "__VITE_PUBLIC_ASSET__801bd8aa__"